import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const QUOTES = [
  {
    text: "We launched 6 SKUs in 9 days. PouchKart turned our packaging into a competitive moat instead of a launch blocker.",
    name: "Riya Mehta",
    title: "Founder, Halal & Honest",
  },
  {
    text: "Zero cylinder cost was a game-changer. We could finally test 4 design variants without burning a lakh.",
    name: "Arvind Rao",
    title: "Head of Brand, NutriPaws Pet",
  },
  {
    text: "The print quality matches our European supplier — at one-third the cost and a quarter of the lead time.",
    name: "Sneha Kapoor",
    title: "Director, Wholesome Co.",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="bg-[#F8F9FA] py-20 md:py-28 border-y border-[#d1d5db]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 md:col-span-6">
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-[#1B3F8F] mb-4 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#F58220]" />
              Brands that ship with us
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-black uppercase leading-[0.95] tracking-tighter">
              We don’t sell pouches.
              <br />We help you{" "}
              <span className="text-[#F58220]">launch faster.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {QUOTES.map((q, i) => (
            <motion.figure
              key={q.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="bg-white border border-[#d1d5db] p-7 md:p-8 flex flex-col"
            >
              <Quote className="text-[#F58220]" size={28} />
              <div className="mt-4 flex items-center gap-1 text-[#F58220]">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={14} className="fill-current" />
                ))}
              </div>
              <blockquote className="mt-5 text-[15px] leading-relaxed text-[#0a1128] font-medium">
                “{q.text}”
              </blockquote>
              <figcaption className="mt-auto pt-7">
                <div className="font-display font-bold text-[#0a1128]">
                  {q.name}
                </div>
                <div className="text-xs font-semibold uppercase tracking-[0.16em] text-[#1B3F8F] mt-1">
                  {q.title}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
